export const messagesAuditEvents = {
    /**
     * payload: { entity: Activity/Project }
     */
    editMessage: `Edit Message Clicked`,
    /**
     * payload: { entity: Activity/Project }
     */
    messageIsEdited: `Message Edited`,
    messageIsAdded: `Approval Request Message Added`,
    /**
     * payload: { entity: Activity/Project }
     */
    messageIsDeleted: `Message Deleted`,
    activityMessageAdded: "Activity Message Added",
    projectMessageAdded: "Project Message Added",
    /**
     * payload: { entity: Activity/Project }
     */
    hoverOnTheListOfRecipients: `Message Email Recipients Viewed`,
    /**
     * payload: { entity: Activity/Project }
     */
    clickOnMention: `Mention Button Clicked`,
    /**
     * payload: { entity: Activity/Project }
     */
    hoverOnTheFollowersList: `Message Followers Viewed`,
    imageAnnotationAdded: "Image Annotation Added",
    mentionAdded: "Mention Enabled",
    reactionUsed: "Reaction Used",
} as const;
